// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-popup[data-v-44ba11bb]  .modal{padding:28px!important}.modal-result-popup[data-v-44ba11bb]{padding:10px 0 21px}.modal-result-popup a[data-v-44ba11bb],.modal-result-popup button[data-v-44ba11bb]{margin-top:12px}h1[data-v-44ba11bb]{font-family:\"Instrument Serif\",Georgia,Times New Roman,serif;font-size:28px;line-height:38px}h1[data-v-44ba11bb],h3[data-v-44ba11bb]{width:100%;font-style:normal;font-weight:400}h3[data-v-44ba11bb]{font-size:16px;line-height:22px}", ""]);
// Exports
module.exports = exports;
